<template>
	<div class="websiteMonitorDetails">
		<overview :details="details" :siteId="siteId" @refresh="refresh"></overview>

		<div v-if="showStatus == 1">
			<checkText :details="details"></checkText>
			<nodeSpeed :details="details"></nodeSpeed>
			<performance :details="details"></performance>
			<score :details="details" v-if="details.pageSpeed"></score>
			<security :details="details"></security>
		</div>

		<!-- 网站异常 -->
		<div class="card" v-if="showStatus == 2">
			<div class="title">网站测速</div>
			<img src="~@/assets/websiteMonitor/siteError.png" alt="" />
			<div class="text">
				<span>
					经过仔细分析和检测，我们发现您的网站出现了一些异常情况。我们已经启动紧急措施，并正在全力解决这些问题。因为有较低的误判概率，您也可以
				</span>
				<span class="refresh" @click="refresh">重新检测</span>
				<span>试一下，感谢您的理解和耐心等待。</span>
			</div>
		</div>

		<!-- 检测失败 -->
		<div class="card" v-if="showStatus == 3">
			<div class="title">网站测速</div>
			<img src="~@/assets/websiteMonitor/monitorError.png" alt="" />
			<div class="text">
				<span>非常抱歉，我们的系统在检测过程中遇到了一些问题，请</span>
				<span class="refresh" @click="refresh">重新检测</span>
				<span>一下，感谢您的理解和耐心等待。</span>
			</div>
		</div>
	</div>
</template>

<script>
import websiteMonitorDetailsComponents from './websiteMonitorDetailsComponents';

export default {
	name: 'websiteMonitorDetails',
	props: ['details', 'showStatus','siteId'],
	components: {
		...websiteMonitorDetailsComponents,
	},
	methods: {
		refresh() {
			this.$emit('refresh');
		},
	},
};
</script>

<style lang="scss" scoped>
.websiteMonitorDetails {
	// padding: 0 20px;

	.card {
		height: 550px;
		background: #ffffff;
		box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
		margin-bottom: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.title {
			text-align: center;
			padding: 40px 0;
			font-size: 28px;
			font-weight: 500;
			color: #333333;
      margin-bottom: 50px;
		}

		.text {
			font-size: 16px;
			font-weight: 400;
			color: #333333;
			margin-top: 45px;
			max-width: 50%;

			.refresh {
				cursor: pointer;
				color: #3da1ff;
			}
		}
	}
}
</style>
